import { render, staticRenderFns } from "./create-obj.vue?vue&type=template&id=67d8482e&scoped=true&"
import script from "./create-obj.vue?vue&type=script&lang=js&"
export * from "./create-obj.vue?vue&type=script&lang=js&"
import style0 from "./create-obj.vue?vue&type=style&index=0&id=67d8482e&prod&lang=scss&"
import style1 from "./create-obj.vue?vue&type=style&index=1&id=67d8482e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d8482e",
  null
  
)

export default component.exports